<template>
  <div v-loading="isLoading">
    <el-card shadow="never">
      <Manifest
        ref="manifest"
        :form-data="formData.manifestData"
      />
    </el-card>
  </div>
</template>
<script>
import Manifest from '@/components/Application/Manage/Carriers/Carrier/Manifest'
export default {
  components: {
    Manifest
  },
  data () {
    return {
      title: 'Manifest',
      breadcrumb: {
        name: 'Manifest',
        route: { name: 'manage-carriers-carrier-configurations-manifest' }
      },
      actions: [
        {
          name: 'Save',
          icon: ['fal', 'save'],
          event: this.save
        }
      ],
      isSaving: false,
      isLoading: false,
      carrier: [],
      formData: {
        manifestData: {
          prefixRequired: false,
          length: null,
          prefixDef: null,
          minDef: null,
          maxDef: null
        }
      }
    }
  },
  mounted () {
    this.loadCarrierById()
  },
  methods: {
    loadCarrierById () {
      this.isLoading = true
      this.$sdk.carrier.read(this.$route.params.carrierId, (builder) => {
      }).then(res => {
        this.carrier = res
        this.formData.manifestData.maxDef = res.config_man_max_def
        this.formData.manifestData.minDef = res.config_man_min_def
        this.formData.manifestData.prefixDef = res.config_man_prefix_def
        this.formData.manifestData.prefixRequired = res.config_man_prefix_req
        this.formData.manifestData.length = res.manifest_length
      })
        .finally(() => { this.isLoading = false })
    },
    save () {
      this.isSaving = true
      this.carrier.config_man_max_def = this.formData.manifestData.maxDef
      this.carrier.config_man_min_def = this.formData.manifestData.minDef
      this.carrier.config_man_prefix_def = this.formData.manifestData.prefixDef
      this.carrier.config_man_prefix_req = this.formData.manifestData.prefixRequired
      this.carrier.manifest_length = this.formData.manifestData.length

      this.$refs.manifest.$refs.form.validate((valid) => {
        if (valid) {
          this.carrier.update()
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
            })
        }
      })
    }
  }
}
</script>
